import OrdercallService from '../ordercall.service';

type StatusName = {
    id: number;
    name: string;
    extra_name: string;
}

class OrderService extends OrdercallService {
    getOrders(page: number, sort?: string, order?: string, status?: string|number, date?: string, countOnPage?: number) {
        sort = sort || 'create_datetime';
        order = order || 'desc';
        countOnPage = countOnPage || 20;
        
        if (typeof status == 'undefined')
            status = '0,1,2,3,4';

        date = date ? `&date=${date}` : '';
        let params = `&page=${page}&sort=${sort}&order=${order}&status=${status}${date}&count_on_page=${countOnPage}`

        return this.getByAction('orders' + params);
    }

    getNewCount(order_old_count?: number) {
        if (typeof order_old_count == 'undefined')
            order_old_count = 0;
        return this.getByAction('new' + '&order_old_count=' + order_old_count.toString() );
    }

    getItems(order_id: number) {
        return this.getByAction('items&order_id=' + order_id.toString());
    }

    deleteOrder(order_id: number) {
        return this.getByAction('order&method=delete&id=' + order_id.toString());
    }

    setStatus(order_id: number, status: number) {
        return this.getByAction('order&method=status&id=' + order_id.toString() + '&status=' + status.toString());
    }

    static getStatusAll(): Array<StatusName> {
        return [
            {id: 0, name: 'Новая', extra_name: 'Новые'},
            {id: 1, name: 'Выполнено', extra_name: 'Выполненные'},
            {id: 2, name: 'В работу', extra_name: 'В работе'},
            {id: 3, name: 'Не отвечает', extra_name: ''},
            {id: 4, name: 'Перезвонить', extra_name: ''},
        ]
    }

    static getStatusNames(): Array<string> {
        return ['Новая', 'Выполнено', 'В работу', 'Не отвечает', 'Перезвонить'];
    }
}

export default OrderService;


// WEBPACK FOOTER //
// ./src/webpack/vue/backend/order.service.ts